import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: Spacings.s24,
      overflow: 'scroll',
    },
    skeleton: {
      flexShrink: 0,
      borderRadius: CornerRadius.r8,
    },
  },
  {
    name: 'template-fallback',
  },
);
export default useStyles;
